import { render, staticRenderFns } from "./CompanyBasicInfo.vue?vue&type=template&id=abdade36&scoped=true&"
import script from "./CompanyBasicInfo.vue?vue&type=script&lang=js&"
export * from "./CompanyBasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./CompanyBasicInfo.vue?vue&type=style&index=0&id=abdade36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abdade36",
  null
  
)

export default component.exports